"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Storage = void 0;
const lz_string_1 = __importDefault(require("lz-string"));
class StorageManager {
    constructor() {
        this.chunck_size = 1024;
    }
    get(name, _default, bUnparse = false) {
        const index = this.getIndex();
        if (index[name]) {
            let data = '';
            for (let i = 0; i < index[name].parts; i++)
                data += localStorage.getItem(name + '_' + i);
            const decompresed = lz_string_1.default.decompress(data);
            return index[name].bParse && !bUnparse ? JSON.parse(decompresed) : decompresed;
        }
        return _default;
    }
    has(name) {
        const index = this.getIndex();
        return typeof index[name] !== 'undefined';
    }
    set(name, data, isJSONString = false) {
        const bParse = isJSONString || typeof data === 'object';
        const compressed = lz_string_1.default.compress(bParse && !isJSONString ? JSON.stringify(data) : data);
        const parts = Math.ceil(compressed.length / this.chunck_size);
        const indexing = {
            bParse,
            parts,
            created: +new Date()
        };
        this.addToIndex(name, indexing);
        for (let i = 0; i < parts; i++) {
            const start = i * this.chunck_size;
            const end = start + this.chunck_size;
            localStorage.setItem(name + '_' + i, compressed.slice(start, end));
        }
    }
    remove(name) {
        const index = this.getIndex();
        if (index[name])
            for (let i = 0; i < index[name].parts; i++)
                localStorage.removeItem(name + '_' + i);
        delete index[name];
        localStorage.setItem('indexing', JSON.stringify(index));
    }
    getIndex() {
        return JSON.parse(localStorage.getItem('indexing') || '{}');
    }
    addToIndex(name, indexing) {
        const index = this.getIndex();
        if (index[name])
            for (let i = 0; i < index[name].parts; i++)
                localStorage.removeItem(name + '_' + i);
        index[name] = indexing;
        localStorage.setItem('indexing', JSON.stringify(index));
    }
}
const Storage = new StorageManager();
exports.Storage = Storage;
